'use client'

import { RegisterCardFormState, useRegisterCardForm } from '@features/payment-methods'
import { createContext, ReactNode, useContext } from 'react'

type RegisterCardFormContextType = {
  formState: RegisterCardFormState
  validationNumeric: (e: React.ChangeEvent<HTMLInputElement>) => void
  handleChange: (e: React.ChangeEvent<HTMLInputElement>) => void
  isFormValid: boolean
}

export const RegisterCardFormContext = createContext<Nullable<RegisterCardFormContextType>>(null)

export const RegisterCardFormProvider = ({ children }: { children: ReactNode }) => {
  const { formState, validationNumeric, handleChange, isFormValid } = useRegisterCardForm()

  return (
    <RegisterCardFormContext.Provider value={{ formState, validationNumeric, handleChange, isFormValid }}>
      {children}
    </RegisterCardFormContext.Provider>
  )
}

export const useRegisterCardFormState = () => {
  const registerCardFormState = useContext(RegisterCardFormContext)
  if (!registerCardFormState) {
    throw new Error('useRegisterCardFormState must be used within a RegisterCardFormProvider')
  }

  const {
    cardNumber1,
    cardNumber2,
    cardNumber3,
    cardNumber4,
    cardExpiryYear,
    cardExpiryMonth,
    cardPassword,
    birthDate,
  } = registerCardFormState.formState.values

  return {
    ...registerCardFormState,
    registerCardDto: {
      cardNumber: `${cardNumber1}${cardNumber2}${cardNumber3}${cardNumber4}`,
      cardExp: `20${cardExpiryYear}${cardExpiryMonth}`,
      cardPassword,
      cardBirthDate: birthDate,
    },
  }
}
